<template>
  <div class="data-list-container">
    <period-side-view
      :isSidebarActive="isSidebarActive"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      @onPeriodUpdated="periodUpdated"
      @onPeriodInserted="periodInserted"
    />
    <vx-card ref="listCard" :title="$t('MRMR.Period.Title')" title-color="black" refresh-content-action @refresh="refreshPeriodList"> 
      <vs-table
            ref="table"
            v-model="selected"
            pagination
            :max-items="itemsPerPage"
            search
            :data="periods"
          >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <feather-icon icon="PlusCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="addNewData" v-b-tooltip.hover :title="$t('AddNew')" />
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" class="pb-4">
              <Pager
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :totalCount="periods.length"
                :queriedItems="queriedItems"
                :pageSizes="[10,20,50]"
                @pageChanged="onPageChanged"
              ></Pager>
            </vs-col>
          </vs-row>
        </div>
        <template slot="thead">
          <vs-th>{{$t('Action')}}</vs-th>
          <vs-th sort-key="name">{{$t('MRMR.Period.Name')}}</vs-th>
          <vs-th sort-key="periodDate">{{$t('MRMR.Period.PeriodDate')}}</vs-th>
          <vs-th>{{$t('MRMR.Period.SubmittedGeoStatementsCount')}}</vs-th>
          <vs-th>{{$t('MRMR.Period.SubmittedEngStatementsCount')}}</vs-th>
          <vs-th>{{$t('MRMR.Period.ApprovedCorpoStatementsCount')}}</vs-th>
          <vs-th>{{$t('MRMR.Period.UnplannedStatementsCount')}}</vs-th>
          <vs-th sort-key="isYearEnd">{{$t('MRMR.Period.IsYearEnd')}}</vs-th>
          <vs-th sort-key="isInternal">{{$t('MRMR.Period.IsInternal')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr.id)"
                  v-b-tooltip.hover :title="$t('Edit')"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.id, tr.name)"
                  v-b-tooltip.hover :title="$t('Delete')"
                />                
                
                <feather-icon
                  icon="FileTextIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="ml-2"
                  @click.stop="navigateToStatements(tr.id)"
                  v-b-tooltip.hover :title="$t('MRMR.Period.OpenPeriodStatementsTooltip')"
                />               
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td width="250px;">
                <p class="font-medium truncate">{{ tr.periodDate | toDate }}</p>
              </vs-td>
              <vs-td width="75px;" :class="tr.submittedGeoStatementsCount == tr.requiredStatementsCount && tr.requiredStatementsCount > 0 ? 'text-success': tr.submittedGeoStatementsCount < tr.requiredStatementsCount && tr.submittedGeoStatementsCount > 0 ? 'text-warning': 'text-danger'">
                <p class="font-medium" style="text-align:center;">{{ tr.submittedGeoStatementsCount }} / {{ tr.requiredStatementsCount }}</p>
                <vs-progress :percent=" tr.submittedGeoStatementsCount / tr.requiredStatementsCount * 100" :color="tr.submittedGeoStatementsCount == tr.requiredStatementsCount && tr.requiredStatementsCount > 0 ? 'success': tr.submittedGeoStatementsCount < tr.requiredStatementsCount && tr.submittedGeoStatementsCount > 0 ? 'warning': 'danger'"></vs-progress>
              </vs-td>
              <vs-td width="75px;" :class="tr.submittedEngStatementsCount == tr.requiredStatementsCount && tr.requiredStatementsCount > 0 ? 'text-success': tr.submittedEngStatementsCount < tr.requiredStatementsCount && tr.submittedEngStatementsCount > 0 ? 'text-warning': 'text-danger'">
                <p class="font-medium" style="text-align:center;">{{ tr.submittedEngStatementsCount }} / {{ tr.requiredStatementsCount }}</p>
                <vs-progress :percent=" tr.submittedEngStatementsCount / tr.requiredStatementsCount * 100" :color="tr.submittedEngStatementsCount == tr.requiredStatementsCount && tr.requiredStatementsCount > 0 ? 'success': tr.submittedEngStatementsCount < tr.requiredStatementsCount && tr.submittedEngStatementsCount > 0 ? 'warning': 'danger'"></vs-progress>
              </vs-td>
              <vs-td width="75px;" :class="tr.approvedCorpoStatementsCount == tr.requiredStatementsCount && tr.requiredStatementsCount > 0 ? 'text-success': tr.approvedCorpoStatementsCount < tr.requiredStatementsCount && tr.approvedCorpoStatementsCount > 0 ? 'text-warning': 'text-danger'">
                <p class="font-medium" style="text-align:center;">{{ tr.approvedCorpoStatementsCount }} / {{ tr.requiredStatementsCount }}</p>
                 <vs-progress :percent=" tr.approvedCorpoStatementsCount / tr.requiredStatementsCount * 100" :color="tr.approvedCorpoStatementsCount == tr.requiredStatementsCount && tr.requiredStatementsCount > 0 ? 'success': tr.approvedCorpoStatementsCount < tr.requiredStatementsCount && tr.approvedCorpoStatementsCount > 0 ? 'warning': 'danger'"></vs-progress>
              </vs-td>
              <vs-td width="75px;" :class="tr.unplannedStatementsCount > 0 ? 'text-warning': 'text-primary'">
                <p class="font-medium" style="text-align:center;">{{ tr.unplannedStatementsCount }}</p>
              </vs-td>
              <vs-td width="75px;">
                <vs-checkbox v-model="tr.isYearEnd" class="mb-2" :disabled="true" ></vs-checkbox>
              </vs-td>
              <vs-td width="75px;">
                <vs-checkbox v-model="tr.isInternal" class="mb-2" :disabled="true" ></vs-checkbox>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>

import periodSideView from "./components/periodSideView.vue";
import moduleMRMR from "../../store/moduleMRMR.js";
import { Pager } from "../../../../shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    Pager,
    periodSideView
  },
  data() {
    return {
      selected: [],    
      itemsPerPage: 20,
      isMounted: false,
      isSidebarActive: false,
      sidebarData: {}
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    periods() {
      return this.$store.state.mrmr.periods;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.periods.length;
    }
  },
  methods: {
    refreshPeriodList() {
      this.$store.dispatch("mrmr/fetchPeriodListItems").then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    onPageChanged(val) {
      this.itemsPerPage = val;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.isSidebarActive = val;
    },
    openDeleteConfirm(id, name) {
      this.$deleteConfirmation({
        text: this.$t('MRMR.Period.ConfirmDelete', { name }),
        accept:  () => this.deleteData(id)
      });
    },
    navigateToStatements(periodId) {
      this.$router.push({ name: 'mrmr-periods-statements', params: { periodId } });
    },
    deleteData(id) {
      this.$store.dispatch("mrmr/removePeriod", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("MRMR.Period.PeriodDeleted"));
        });
    },
    editData(periodId) {
      this.$cqrsGet("geo/mrmr/statementPeriods/find/", { params : { id: periodId }})
        .then((response) => {
          this.sidebarData = response.data.model;
          this.toggleDataSidebar(true);
        })
        .catch((error) => {
          this.$notifyLoadingError(error.message);
        });
    },

    periodUpdated() {
      this.$notifySaveSuccess();
      this.toggleDataSidebar(false);

    },

    periodInserted() {
      this.$notifySuccess(this.$t('InsertSuccess'));
      this.toggleDataSidebar(false);
    }
  },
  created() {
    if (!moduleMRMR.isRegistered) {
      this.$store.registerModule("mrmr", moduleMRMR);
      moduleMRMR.isRegistered = true;
    }
  },
  mounted() {
    if (this.$store.state.mrmr.projects.length === 0) {

      this.$vs.loading();

      this.$store.dispatch("mrmr/fetchAllProjects").then(() => {
        if (!this.isMounted) {
          this.$refs.listCard.refreshcard();
        }

        this.isMounted = true;

      }).finally(() => {
        this.$vs.loading.close();
      })
    } 
    else {
      if (!this.isMounted) {
        this.$refs.listCard.refreshcard();
      }
      this.isMounted = true;
    }
  }
};
</script>